// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j0-2";
export var container = "_j0-4";
export var dismissButton = "_j0-3";
export var hasPaddingBottom = "_j0-6";
export var last = "_j0-e";
export var scrollbarThumb = "_j0-c";
export var scrollbarTrack = "_j0-b";
export var selected = "_j0-9";
export var spin = "_j0-1";
export var spinning = "_j0-0";
export var suggestionItem = "_j0-d";
export var suggestionsPanel = "_j0-5";
export var tonePill = "_j0-8";
export var tonesContainer = "_j0-7";
export var unselected = "_j0-a";